__turbopack_context__.v({
  "icon": "p8Sx3W_icon",
  "indicator": "p8Sx3W_indicator",
});
